import React from 'react'
import { Row, Col } from 'antd'
import './index.css'
import DetailItem from '../../CSIComponents/DetailItem'
import ReadOnlyTextarea from '../../CSIComponents/ReadOnlyTextarea'
import Collapse, { Panel } from '../../ui/Collapse'

interface propsType {
  detailData: object | any
}
const GeneralEnvironmentalProgramDetail = (props: propsType) => {
  const detailData =
    props?.detailData?.environmentalimpact?.general?.envprograms || []

  return (
    <Collapse
      defaultActiveKey={detailData.map((_: object, i: number) => i)}
      multiCollapseButton>
      <>
        {detailData.map((item: { name: string; desc: string }, i: number) => (
          <Panel header={`Environmental Program ${i + 1}`} key={i}>
            <Row gutter={24}>
              <Col span={6} key={`col1${i}`}>
                <DetailItem value={item.name} label='Name'></DetailItem>
              </Col>
              <Col span={12} key={`col2${i}`}>
                <ReadOnlyTextarea
                  label='Description'
                  value={item.desc}
                  minRows={1}
                />
              </Col>
            </Row>
          </Panel>
        ))}
      </>
    </Collapse>
  )
}

export default GeneralEnvironmentalProgramDetail
